import React from "react";

import { useStateQuery } from "@/lib/useStateQuery";

export const factoryUseModalX = (options: { queryName: string }) => () => {
  const [id, setId] = useStateQuery<string | undefined>(options.queryName);
  return React.useMemo(
    () => ({
      isCreating: id === "new",
      isEditing: id !== undefined && id !== "new",
      editingId: id !== undefined && id !== "new" ? id : undefined,
      startCreate: () => {
        setId("new");
      },
      startEdit: (id: string | number) => {
        setId(String(id));
      },
      finishInteraction: () => setId(),
    }),
    [id, setId],
  );
};
